import React from 'react';
import loadable from '@loadable/component';
import { withError } from '../../../shared/components/error-boundary';

import { Helpers } from '../../../core/src/helpers';
import useDeviceInfo from '../../../hooks/useDeviceInfo';
import CarepackHardward from './carepack-hardward';

const DesktopCartItem = loadable(() => Helpers.retryFunc(() => import('./cart-item-desktop')));
const MobileCartItem = loadable(() => Helpers.retryFunc(() => import('./cart-item-mobile')));

//temp component, this should come from GFE eventually
export default withError(props => {
    const { key, missingHW, refreshCarePackInfo, ...restProps } = props;
    const { item } = restProps;
    const { device } = useDeviceInfo(['device']);
    return (
        <React.Fragment key={key}>
            {device === 'mobile' ? <MobileCartItem {...restProps} /> : <DesktopCartItem {...restProps} />}
            <CarepackHardward item={item} missingHW={missingHW} refreshCarePackInfo={refreshCarePackInfo} />
        </React.Fragment>
    );
});
